export default __webpack_public_path__ + "static/media/training1.d3774a10.jpg";